import { expValEquals } from '@confluence/feature-experiments';
import { StatsigConfigurations } from '@confluence/statsig-configurations/entry-points/StatsigConfigurations.ts';

export type MigratedMacroExtensionKey =
	| 'attachments'
	| 'blog-posts'
	| 'change-history'
	| 'contributors'
	| 'detailssummary'
	| 'iframe'
	| 'include'
	| 'pagetree'
	| 'pagetreesearch'
	| 'profile'
	| 'profile-picture'
	| 'recently-updated'
	| 'viewpdf'
	| 'viewxls'
	| 'widget'
	| 'contentbylabel'
	| 'listlabels'
	| 'popular-labels'
	| 'tasks-report-macro';

export const MIGRATED_MACRO_EXTENSION_KEYS: readonly MigratedMacroExtensionKey[] = [
	'attachments',
	'blog-posts',
	'change-history',
	'contributors',
	'detailssummary',
	'iframe',
	'include',
	'pagetree',
	'pagetreesearch',
	'profile',
	'profile-picture',
	'recently-updated',
	'viewpdf',
	'viewxls',
	'widget',
	'contentbylabel',
	'listlabels',
	'popular-labels',
	'tasks-report-macro',
];

const getExperimentValue = (extensionKey: MigratedMacroExtensionKey): boolean => {
	switch (extensionKey) {
		case 'blog-posts':
			return expValEquals('cc_rewrite_blog_posts_legacy_macro', 'isEnabled', true);
		case 'contributors':
			return expValEquals('cc_rewrite_contributors_legacy_macro', 'isEnabled', true);
		case 'detailssummary':
		case 'profile':
		case 'profile-picture':
			return expValEquals('cc_macro_full_ssr_support', 'isEnabled', true);
		case 'contentbylabel':
		case 'iframe':
			return true;
		case 'listlabels':
			return expValEquals('cc_rewrite_listlabels_legacy_macro', 'isEnabled', true);
		case 'pagetree':
			return expValEquals('cc_rewrite_pagetree_legacy_macro', 'isEnabled', true);
		case 'pagetreesearch':
			return true;
		case 'popular-labels':
			return expValEquals('cc_rewrite_popular_labels_legacy_macro', 'isEnabled', true);
		case 'recently-updated':
			return expValEquals('cc_rewrite_recently_updated_legacy_macro', 'isEnabled', true);
		case 'viewpdf':
			return expValEquals('cc_rewrite_viewpdf_macro', 'isEnabled', true);
		case 'viewxls':
			return expValEquals('cc_rewrite_viewxls_legacy_macro', 'isEnabled', true);
		case 'widget':
			return expValEquals('cc_rewrite_widget_legacy_macro', 'isEnabled', true);
		case 'attachments':
			return expValEquals('cc_rewrite_attachments_legacy_macro', 'isEnabled', true);
		case 'include':
			return expValEquals('cc_rewrite_page_include_legacy_macro', 'isEnabled', true);
		case 'tasks-report-macro':
			return expValEquals('cc_rewrite_tasks_report_macro', 'isEnabled', true);
		case 'change-history':
			return expValEquals('cc_rewrite_change_history_legacy_macro', 'isEnabled', true);
		default:
			return false;
	}
};

const isMigratedMacroExtensionKey = (key: string): key is MigratedMacroExtensionKey =>
	(MIGRATED_MACRO_EXTENSION_KEYS as readonly string[]).includes(key);

export const isMigratedMacroImplEnabled = (extensionKey: string): boolean => {
	const overrideList = StatsigConfigurations.getStringList(
		'cc_macro_override_to_legacy_renderer',
		[],
	);

	if (overrideList.includes(extensionKey)) {
		return false;
	}

	if (!isMigratedMacroExtensionKey(extensionKey)) {
		return false;
	}

	return getExperimentValue(extensionKey);
};
